import { useShortIdContext } from '@air/provider-short-id';

import { useCanShowNestedItemsChip } from '~/components/v2/components/shared/gallery/useCanShowNestedItemsChip';
import { useGalleryNestedHeaderControls } from '~/components/v2/components/shared/gallery/useGalleryNestedHeaderControls';

/** Nested controls for a public board, including a board drilled inside a showcase. */
export const usePublicBoardGalleryNestedControls = () => {
  const { presentationSettings } = useShortIdContext();
  const isExpandNestedDisabled = Boolean(presentationSettings?.lockedControls?.expandNested);
  const { canShowNestedItemsChip } = useCanShowNestedItemsChip({
    isDisabled: isExpandNestedDisabled,
  });

  return useGalleryNestedHeaderControls({
    canShowNestedItemsChip,
    isDisabled: isExpandNestedDisabled,
    isNestedChipHost: true,
  });
};
